import { apiSlice } from "../../app/api/apiSlice";

const URL = "/tasks";

export const tasksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => URL,
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map((t) => ({ type: "Task", id: t._id || t.id })),
              { type: "Task", id: "LIST" },
            ]
          : [{ type: "Task", id: "LIST" }],
    }),
    getTask: builder.query({
      query: (id) => `${URL}/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Task", id }],
    }),
    createTask: builder.mutation({
      query: (task) => ({
        url: URL,
        method: "POST",
        body: task,
      }),
      invalidatesTags: [{ type: "Task", id: "LIST" }],
    }),
    updateTask: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `${URL}/${id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: (_res, _err, { id }) => [
        { type: "Task", id },
        { type: "Task", id: "LIST" },
      ],
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `${URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_res, _err, id) => [
        { type: "Task", id },
        { type: "Task", id: "LIST" },
      ],
    }),
    addTaskComment: builder.mutation({
      query: ({ id, text }) => ({
        url: `${URL}/${id}/comments`,
        method: "POST",
        body: { text },
      }),
      invalidatesTags: (_res, _err, { id }) => [{ type: "Task", id }],
    }),
    deleteTaskComment: builder.mutation({
      query: ({ id, commentId }) => ({
        url: `${URL}/${id}/comments/${commentId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_res, _err, { id }) => [{ type: "Task", id }],
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useDeleteTaskMutation,
  useAddTaskCommentMutation,
  useDeleteTaskCommentMutation,
} = tasksApiSlice;
